class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');

        this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        })
    }

    close() {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    }
}

customElements.define('details-disclosure', DetailsDisclosure);

/* Blak Sand — open header dropdowns on hover for mouse users (15 Sep 2026).
   Touch devices are excluded: on touch, the first tap would be spent on hover. */
(function () {
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
    if (!fine || !fine.matches) return;

    function init() {
        var nav = document.querySelector('.site-nav');
        if (!nav) return;
        var closeTimer;

        function openOnly(target) {
            var all = nav.querySelectorAll('details.site-nav--has-dropdown');
            for (var i = 0; i < all.length; i++) {
                var d = all[i];
                if (d === target) continue;
                if (target && d.contains(target)) continue;
                d.removeAttribute('open');
                var s = d.querySelector('summary');
                if (s) s.setAttribute('aria-expanded', 'false');
            }
            if (target) {
                target.setAttribute('open', '');
                var s2 = target.querySelector('summary');
                if (s2) s2.setAttribute('aria-expanded', 'true');
            }
        }

        nav.addEventListener('mouseover', function (event) {
            var d = event.target.closest ? event.target.closest('details.site-nav--has-dropdown') : null;
            clearTimeout(closeTimer);
            openOnly(d);
        });

        nav.addEventListener('mouseleave', function () {
            closeTimer = setTimeout(function () { openOnly(null); }, 150);
        });

        nav.addEventListener('click', function (event) {
            var s = event.target.closest ? event.target.closest('summary') : null;
            if (s && nav.contains(s)) event.preventDefault();
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') openOnly(null);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
